import React, { useState, useCallback } from 'react';
import { Copy, Check } from 'lucide-react';

// CharCount + CopyBtn — moved verbatim out of AdCopyModule.tsx so both the module
// and LeadFormPreview.tsx can import them without a circular ES-module dependency
// (AdCopyModule imports LeadFormsTab, so exporting these from AdCopyModule would
// create a cycle). Their class names (.ac-char-count, .ac-copy-btn) are global via
// AdCopyModule.css, which AdCopyModule.tsx imports once — do NOT import the CSS
// here (it would add a second, redundant CSS entry to the build graph).

export const CharCount: React.FC<{ text: string; limit: number }> = ({ text, limit }) => {
    const len = text?.length ?? 0;
    const pct = len / limit;
    const cls = len > limit ? 'char-over' : pct > 0.9 ? 'char-warn' : 'char-ok';
    return <span className={`ac-char-count ${cls}`}>{len}/{limit}</span>;
};

export const CopyBtn: React.FC<{ text: string }> = ({ text }) => {
    const [copied, setCopied] = useState(false);
    const handle = useCallback(async () => {
        try { await navigator.clipboard.writeText(text); setCopied(true); setTimeout(() => setCopied(false), 2000); } catch {}
    }, [text]);
    return (
        <button className={`ac-copy-btn ${copied ? 'copied' : ''}`} onClick={handle} title="Copy">
            {copied ? <Check size={11} /> : <Copy size={11} />}
        </button>
    );
};
